import http from '../../../lib/http/httpClient';
import { clearAccessToken, clearSelectedCust, clearUser } from '../../../lib/auth/tokenService';
import {
  SendOtpRequest,
  SendOtpResponse,
  VerifyOtpRequest,
  LoginResponse,
  PermissionsResponse,
  MenuPermission,
} from '../types';

export const sendOtp = async (mobileNo: string): Promise<SendOtpResponse> => {
  const request = { mobile_no: mobileNo };
  return await http.post<SendOtpResponse>('/api/v1/cp/auth/send-otp', request, { retry: false });
};

export const resendOtp = async (mobileNo: string): Promise<SendOtpResponse> => {
  const request = { mobile_no: mobileNo };
  return await http.post<SendOtpResponse>('/api/v1/cp/auth/resend-otp', request, { retry: false });
};

export const verifyOtp = async (mobileNo: string, otp: string): Promise<LoginResponse> => {
  const request = { mobile_no: mobileNo, otp };

  const data = await http.post<LoginResponse>('/api/v1/cp/auth/verify-otp', request, { retry: false });
  if (!data?.access_token) {
    throw new Error('No access token received');
  }
  return data;
};

export const fetchPermissions = async (): Promise<PermissionsResponse> => {
  try {
    const data = await http.get<PermissionsResponse>('/api/v1/cp/auth/permissions');
    return data;
  } catch (error) {
    console.error('Error fetching permissions:', error);
    throw error;
  }
};

export const logout = async (): Promise<void> => {
  try { 
    await http.post('/api/v1/cp/auth/logout', null, { retry: false }); 
  } catch(error) {
    console.error('Error during logout:', error);
  } finally {
    clearAccessToken();
    clearUser();
    clearSelectedCust();
  }
};
